import { msalConfig, loginRequest, protectedResources } from './auth-config';
import { getClaimsFromStorage } from './storage-utils';
import { IPublicClientApplication, PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';

export let finalMSALConfig;

/**
 * Here we pass the configuration parameters to create an MSAL instance.
 * For more info, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/v2-docs/configuration.md
 */
export function MSALInstanceFactory(): IPublicClientApplication {
  finalMSALConfig = {
    ...msalConfig,
    auth: { ...msalConfig.auth, clientId: JSON.parse(sessionStorage.getItem('office365'))?.clientId },
  };
  return new PublicClientApplication(finalMSALConfig);
}

/**
 * Set your default interaction type for MSALGuard here. If you have any
 * additional scopes you want the user to consent upon login, add them here as well.
 */
export function MsalGuardConfigurationFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: loginRequest,
  };
}

/**
 * MSAL Angular will automatically retrieve tokens for resources
 * added to protectedResourceMap. For more info, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/v2-docs/initialization.md#get-tokens-for-web-api-calls
 */
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();

  protectedResourceMap.set(protectedResources.graphMe.endpoint, protectedResources.graphMe.scopes);
  protectedResourceMap.set(protectedResources.graphContacts.endpoint, protectedResources.graphContacts.scopes);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
    authRequest: (msalService, httpReq, originalAuthRequest) => {
      const resource = new URL(httpReq.url).hostname;
      const claim =
        msalService.instance.getActiveAccount()! &&
        getClaimsFromStorage(
          `cc.${finalMSALConfig.auth.clientId}.${msalService.instance.getActiveAccount()?.idTokenClaims
            ?.oid}.${resource}`
        )
          ? window.atob(
              getClaimsFromStorage(
                `cc.${finalMSALConfig.auth.clientId}.${msalService.instance.getActiveAccount()?.idTokenClaims
                  ?.oid}.${resource}`
              )
            )
          : undefined; // claims challenge e.g {"access_token":{"xms_cc":{"values":["cp1"]}}}
      return {
        ...originalAuthRequest,
        claims: claim,
      };
    },
  };
}
